'use client';

import { useCallback } from 'react';
import { FetchWithGuardRequestInit, fetchWithGuard } from '@spikemark/core';

export function useFetcher<TResult>(
  path: string,
  method?: RequestInit['method'],
  init?: FetchWithGuardRequestInit
): () => Promise<TResult>;

export function useFetcher<TResult, TParams>(
  path: string,
  method?: RequestInit['method'],
  init?: FetchWithGuardRequestInit
): (params: TParams) => Promise<TResult>;

export function useFetcher<TResult, TParams>(
  path: string,
  method: RequestInit['method'] = 'GET',
  init?: FetchWithGuardRequestInit
): (params: TParams | undefined) => Promise<TResult> {
  return useCallback(
    (params: TParams | undefined) => fetchWithGuard<TResult, TParams>(path, method, params, init),
    [path, init]
  );
}
